import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Card } from "react-bootstrap";
import { openModal } from "../../../../../Library/ModalPopUp";
import { MessageError, MessageSuccess } from "../ProfileUI";
import moment from "moment";
import {
  SelectCountry,
  SelectReligi,
} from "../../_core/SelectInput";
import {
  handleKeyDown,
  validateCellular,
  validateIdTypeDescription,
  validateName,
} from "../../_core/_core";
import { UPDATE_CANDIDATE, UPDATE_STUDENT_DATA } from "../../API";
import { EncodeURIComponentSafe } from "../../../../../Library/GlobalHelper";

export default function CardBio({ data, ReloadDataStd, enrollment }) {
  const has_enrollment = Object.values(enrollment).length > 0 ? true : false;
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    // firstname: data?.firstname || "",
    // middlename: data?.middlename || "",
    // lastname: data?.lastname || "",
    // birthdate: moment(data.birthdate || undefined).toDate(),
    gender: data?.gender || "",
    cellular: data?.cellular || "",
    idtype_id: data?.idtype_id ? data.idtype_id.toString() || 0 : "0",
    idtype_description: data?.idtype_description || "",
    nisn: data?.nisn || "",
  });
  const [birthcity, setBirthcity] = useState(data?.birthplace || "");
  const [birthcountry, setBirthcountry] = useState(data?.birthcountry?.id || 0);
  const [birthcountry_name, setBirthcountryName] = useState(data?.birthcountry?.name || "");
  const [religi_id, setReligiID] = useState(data?.religion?.id || 0);
  const [citizenship, setCitizenship] = useState(data?.citizenship_id || 0);

  const validateForm = () => {
    const newErrors = {};
    const mandatoryFields = [
      "gender",
      "cellular",
      "idtype_id",
      "idtype_description",
      "nisn",
    ];

    mandatoryFields.forEach((field) => {
      if (field === "idtype_id") {
        if (!formData[field] || formData[field] === "0") {
          newErrors[field] = "This field is required";
        }
      } else if (!formData[field]) {
        newErrors[field] = "This field is required";
      }
    });

    // Validasi untuk fields yang berada di luar formData

    if (!birthcity) newErrors.birthcity = "This field is required";
    if (!birthcountry) newErrors.birthcountry = "This field is required";
    if (!religi_id) newErrors.religi_id = "This field is required";
    if (!citizenship) newErrors.citizenship = "This field is required";

    // Validasi tambahan untuk idtype_description
    if (formData.idtype_id && formData.idtype_description) {
      const idTypeError = validateIdTypeDescription(
        formData.idtype_description,
        formData.idtype_id
      );
      if (idTypeError) newErrors.idtype_description = idTypeError;
    }

    setErrors(newErrors);
    return newErrors; // Returns true if no errors
  };

  useEffect(() => {
    validateForm();
  }, [data, formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    validateForm();

    if (name === "idtype_description") {
      if (formData.idtype_id === "1") {
        newValue = value.replace(/\D/g, "").slice(0, 16);
      } else if (formData.idtype_id === "2") {
        newValue = value
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, "")
          .slice(0, 15);
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    // Validate only name fields
    if (["firstname", "lastname"].includes(name)) {
      const error = validateName(value, name);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
    } else if (name === "cellular") {
      const error = validateCellular(newValue);
      if (error) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          cellular: error,
        }));
      }
    } else if (name === "idtype_description") {
      const error = validateIdTypeDescription(newValue, formData.idtype_id);
      setErrors((prevErrors) => ({
        ...prevErrors,
        idtype_description: error,
      }));
    }
  };

  useEffect(() => {
    if (citizenship === 103) {
      setFormData({ ...formData, idtype_id: "1" });
    } else {
      setFormData({ ...formData, idtype_id: "0" });
    }
    validateForm();
  }, [citizenship]);

  useEffect(() => {
    if (formData.idtype_id) {
      setFormData({
        ...formData,
        idtype_description: data?.idtype_description || "",
      });
      setErrors({ ...errors, idtype_description: "" });
    }
    validateForm();
  }, [formData.idtype_id]);

  const [submit, setSubmit] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const HandlerSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      setSubmit({ loading: true, message: "", data: [] });
      const param = {
        ...formData,
        // firstname: EncodeURIComponentSafe(formData.firstname),
        // middlename: formData.middlename ? EncodeURIComponentSafe(formData.middlename) : "",
        // lastname: formData.lastname ? EncodeURIComponentSafe(formData.lastname) : "",
        idtype_id: parseInt(formData.idtype_id),
        citizenship_id: citizenship,
        // birthdate: moment(formData.birthdate).format("YYYY-MM-DD"),
        birthplace: EncodeURIComponentSafe(birthcity),
        birthcountry_id: parseInt(birthcountry),
        religion_id: parseInt(religi_id),
        idtype_description: EncodeURIComponentSafe(formData.idtype_description),
        studentdata_id: data.bio_id,
      };
      
      let is_finish = false;
      if (has_enrollment) {
        const param_enrollment = {
          id: enrollment?.regstudent?.id,
          birthplace: param.birthplace,
          birthcountry: EncodeURIComponentSafe(birthcountry_name),
          gender: param.gender,
          religion: param.religion_id,
          citizenship: param.citizenship_id,
          mobile: param.cellular
        }
        if (param.idtype_id === 1) {
          param_enrollment.idtype_ktp = EncodeURIComponentSafe(formData.idtype_description);
        } else if (param.idtype_id === 2) {
          param_enrollment.idtype_passport = EncodeURIComponentSafe(formData.idtype_description);
        }
        console.log(param_enrollment);
        try {
          const update_data = await UPDATE_CANDIDATE(param_enrollment);
          console.log(update_data);
        } catch (error) {
          console.log(error);
        }
        is_finish = true;
      } else {
        is_finish = true;
      }

      if (is_finish) {
        try {
          const results = await UPDATE_STUDENT_DATA(param);
          if (results.data && Object.values(results.data).length > 0) {
            openModal({
              message: <MessageSuccess message={"Successfully saved"} />,
            });
            ReloadDataStd();
          } else {
            openModal({
              message: (
                <MessageError message={results.message} title="Failed Save" />
              ),
            });
          }
          setSubmit({ loading: false, message: "", data: results });
        } catch (error) {
          setSubmit({ loading: false, message: error?.message, data: [] });
          openModal({
            message: (
              <MessageError message={error?.message} />
            ),
          });
        }
      } else {
        setSubmit({ loading: false, message: "No data post founded", data: [] });
        openModal({
          message: (
            <MessageError
              message={
                "No data post founded."
              }
            />
          ),
        });
      }

    } else {
      console.log("Form has errors", errors);
      openModal({
        message: (
          <MessageError
            message={
              "Please verify your input and ensure it is completed correctly."
            }
          />
        ),
      });
    }
  };

  return (
    <Card>
      <Card.Body>
        <form
          method="post"
          onSubmit={(e) => HandlerSubmit(e)}
          autoComplete="off"
        >
          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Fullname <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8">
              <div className="form-control form-control-lg">
                {data.fullname}
              </div>
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Birth Date/Place <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8">
              <div className="row">
                <div className="col-lg-4 fv-row fv-plugins-icon-container">
                  <div className="form-control">
                    {moment(data.birthdate).format('DD MMM YYYY')}
                  </div>
                </div>
                <div className="col-lg-4 fv-row fv-plugins-icon-container">
                  <input type="text" className="form-control form-control-lg form-control-solid" value={birthcity} onChange={(e) => setBirthcity(e.target.value)} placeholder="Birth Place (City)" />
                  {errors.birthcity && (
                    <div className="text-danger">{errors.birthcity}</div>
                  )}
                </div>
                <div className="col-lg-4 fv-row fv-plugins-icon-container">
                  <SelectCountry
                    data={birthcountry}
                    setData={setBirthcountry}
                    isSolid={true}
                    setCountryName={setBirthcountryName}
                  />
                  {errors.birthcountry && (
                    <div className="text-danger">{errors.birthcountry}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Gender <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8 align-items-center">
              <div className="gender px-8">
                <label className="mr-8">
                  <input
                    type="radio"
                    name="gender"
                    className="form-check-input mr-2"
                    value={"p"}
                    checked={formData.gender === "p"}
                    onChange={(e) =>
                      setFormData({ ...formData, gender: e.target.value })
                    }
                  />
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="gender"
                    className="form-check-input mr-2"
                    value={"w"}
                    checked={formData.gender === "w"}
                    onChange={(e) =>
                      setFormData({ ...formData, gender: e.target.value })
                    }
                  />
                  Female
                </label>
              </div>
              {errors.gender && (
                <div className="text-danger">{errors.gender}</div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Religion <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8 align-items-center">
              <SelectReligi
                data={religi_id}
                setData={setReligiID}
                isSolid={true}
              />
              {errors.religi_id && (
                <div className="text-danger">{errors.religi_id}</div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Citizenship <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8 align-items-center">
              <SelectCountry
                data={citizenship}
                setData={setCitizenship}
                isSolid={true}
              />
              {errors.citizenship && (
                <div className="text-danger">{errors.citizenship}</div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Mobile Number <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8 align-items-center">
              <input
                type="text"
                name="cellular"
                className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                onKeyDown={handleKeyDown}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                value={formData.cellular}
                onChange={handleInputChange}
              />
              {errors.cellular && (
                <div className="text-danger">{errors.cellular}</div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Type of Identification <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8 align-items-center">
              <select
                name="idtype_id"
                className="form-control form-control-lg form-control-solid"
                value={formData.idtype_id}
                onChange={handleInputChange}
              >
                <option value="0">Choose One</option>
                <option value="1">KTP</option>
                <option value="2">Passport</option>
              </select>
              {errors.idtype_id && (
                <div className="text-danger">{errors.idtype_id}</div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              {formData.idtype_id === "1"
                ? "KTP (Indonesian)"
                : formData.idtype_id === "2"
                  ? "Passport"
                  : "ID Card Number"}
              <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8 align-items-center">
              <input
                type="text"
                name="idtype_description"
                className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${errors.idtype_description ? "is-invalid" : ""
                  }`}
                value={formData.idtype_description}
                onChange={handleInputChange}
              />
              {errors.idtype_description && (
                <div className="text-danger">{errors.idtype_description}</div>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-4 col-form-label required font-weight-semibold h6">
              Nomor Induk Siswa Nasional (NISN){" "}
              <sup className="text-danger">*</sup>
            </label>
            <div className="col-lg-8 align-items-center">
              <input
                type="text"
                name="nisn"
                className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                onKeyDown={handleKeyDown}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                value={formData.nisn}
                onChange={handleInputChange}
              />
              {errors.nisn && <div className="text-danger">{errors.nisn}</div>}
            </div>
          </div>

          <div className="text-right mt-8">
            <button
              className="btn btn-lg btn-primary mr-3"
              type="submit"
              disabled={submit.loading}
            >
              {submit.loading ? "Processing..." : "Save Changes"}
            </button>
          </div>
        </form>
      </Card.Body>
    </Card>
  );
}
